import React from 'react';
import { Grid, TextField, MenuItem } from '@material-ui/core';
import { FORM_DICTIONARY } from './schemas/formFields';

export function FormularioAsistencia({ state, onChange, onError, pintarSelect, programaOpciones, modalidadOpciones, tipoAsesoriasOpciones, formasAsesoriasOpciones, profesionalesOpciones = [], modalidadAutoLlenada = false, profesionalDisabled = false }) {
    const campos = FORM_DICTIONARY.asistencia;
    const campos_generales = FORM_DICTIONARY.generales;
    return (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            {/* Campo 1: Nombre Completo - OCULTO (pero se guarda) */}
            <Grid item xs={12} style={{display: 'none'}}>
                <TextField
                    fullWidth
                    required
                    label={campos_generales.nombre.label}
                    name={campos_generales.nombre.name}
                    value={state.nombre_completo.valor}
                    onChange={onChange}
                    error={onError(state.nombre_completo.error)}
                    helperText={state.nombre_completo.error}
                />
            </Grid>

            {/* Campo 2: Programa académico - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{display: 'none'}}>
                {pintarSelect(campos.programa.label, campos.programa.name, programaOpciones)}
            </Grid>

            {/* Campo 3: Documento de identidad - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{display: 'none'}}>
                <TextField
                    fullWidth
                    required
                    label={campos_generales.documento.label}
                    name={campos_generales.documento.name}
                    value={state.documento.valor}
                    onChange={onChange}
                    error={onError(state.documento.error)}
                    helperText={state.documento.error}
                />
            </Grid>

            {/* Campo 4: Celular - OCULTO (pero se guarda) */}
            <Grid item xs={12} md={6} style={{display: 'none'}}>
                <TextField
                    fullWidth
                    required
                    type="number"
                    label={campos.celular.label}
                    name={campos.celular.name}
                    value={state.celular.valor}
                    onChange={onChange}
                    error={onError(state.celular.error)}
                    helperText={state.celular.error}
                />
            </Grid>

            {/* Campo 5: Modalidad */}
            <Grid item xs={12} md={6}>
                {pintarSelect(campos.modalidad.label, campos.modalidad.name, modalidadOpciones)}
            </Grid>

            {/* Campo 6: Tipo de asesoría */}
            <Grid item xs={12} md={6}>
                {pintarSelect(campos.tipo_asesoria.label, campos.tipo_asesoria.name, tipoAsesoriasOpciones)}
            </Grid>

            {/* Campo 7: Forma de asesoría */}
            <Grid item xs={12} md={6}>
                {pintarSelect(campos.forma_asesoria.label, campos.forma_asesoria.name, formasAsesoriasOpciones)}
            </Grid>

            {/* Campo 8: Profesional / Funcionario PASPE */}
            <Grid item xs={12} md={6}>
                {profesionalDisabled ? (
                    // En PASPE: TextField deshabilitado
                    <TextField
                        fullWidth
                        required
                        label={campos.funcionario_paspe.label}
                        name={campos.funcionario_paspe.name}
                        value={state.funcionario_paspe.nombre || state.funcionario_paspe.valor}
                        disabled={true}
                        error={onError(state.funcionario_paspe.error)}
                        helperText=""
                    />
                ) : (
                    // En remitente: Select con opciones
                    <TextField
                        select
                        fullWidth
                        required
                        label={campos.funcionario_paspe_select.label}
                        name={campos.funcionario_paspe_select.name}
                        value={state.funcionario_paspe.valor}
                        onChange={onChange}
                        error={onError(state.funcionario_paspe.error)}
                        helperText={state.funcionario_paspe.error || "Selecciona el profesional"}
                    >
                        {(Array.isArray(profesionalesOpciones) && profesionalesOpciones.length > 0) ? (
                            profesionalesOpciones.map((prof) => (
                                <MenuItem key={prof.value} value={prof.value}>{prof.label}</MenuItem>
                            ))
                        ) : (
                            <MenuItem disabled>No hay profesionales disponibles</MenuItem>
                        )}
                    </TextField>
                )}
            </Grid>
        </Grid>
    );
}
